'use strict';

import register from './core';
import '../functions/jquery-global';
import { keys } from '../functions/search-common';

register('handle-filter-buttons', function (element) {
  var executeSearch = function ($filterButton) {
    $filterButton.siblings('input').attr('checked', 'checked');
    $('#search-form').trigger('submit');
  };

  $(element).on('click', '[data-filter-button]', function (event) {
    executeSearch($(this));
  });

  $(element).on('keypress', '[data-filter-button]', function (event) {
    if (event.which === keys.enter)
      executeSearch($(this));
  });
});
